import { EntityInfoCard, useEntity } from '@backstage/plugin-catalog-react';
import { Flex, Link } from '@backstage/ui';
import { CodespaceCard } from '../CodespaceCard/CodespaceCard';
import { useRepositoryCodespaces } from '../../hooks/useCodespaces';
import { getEntityRepoRef } from '../../utils/entityRepoRef';

const codespacesHeaderActions = <Link href="/github-codespaces">See all</Link>;

export const EntityCodespacesCard = () => {
  const { entity } = useEntity();
  const repoRef = getEntityRepoRef(entity);
  const { value: codespaces, loading, error } = useRepositoryCodespaces(repoRef);

  if (!repoRef) {
    return null;
  }

  // Stay hidden while loading so the card never flashes in and out for repos
  // without codespaces. It only mounts once we know there is content to show.
  if (loading) {
    return null;
  }

  if (error) {
    return null;
  }

  const resolvedCodespaces = codespaces ?? [];
  if (resolvedCodespaces.length === 0) {
    return null;
  }

  return (
    <EntityInfoCard title="Codespaces" headerActions={codespacesHeaderActions}>
      <Flex direction="column" gap="4">
        {resolvedCodespaces.map(codespace => (
          <CodespaceCard key={codespace.id} codespace={codespace} renderTransparent />
        ))}
      </Flex>
    </EntityInfoCard>
  );
};
